var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBonus4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H192V192H16C7.16344 192 0 184.837 0 176V16Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8808 125.964H131.803C140.955 125.964 147.919 123.186 152.439 118.365C156.929 113.576 158.436 107.37 157.839 101.666C157.249 96.0162 154.566 90.4761 150.143 86.7846C146.874 84.0562 142.748 82.432 138.149 82.4988C135.85 71.9002 128.612 65.1988 120.088 63.0976C112.836 61.3103 104.806 62.9468 98.8857 68.0339C94.163 61.3048 88.3414 56.9259 82.0571 54.7175C74.039 51.8999 65.7246 52.7829 58.8305 56.1654C51.9587 59.537 46.3349 65.4729 43.7721 72.9697C41.6631 79.1393 41.7151 86.1119 44.5307 93.1853C42.6722 94.2567 40.9513 95.5621 39.493 97.0976C36.7436 99.9926 34.7854 103.894 35.061 108.484C35.1179 114.156 37.9165 118.7 42.0752 121.672C46.1555 124.588 51.4485 125.964 56.8808 125.964Z",
    fill: "white",
    stroke: "url(#paint0_linear_7529_5197)",
    strokeWidth: 9.92892
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    transform: "matrix(-1 0 0 1 142 100.676)",
    fill: "#1EBEAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119 131.174C119.654 131.174 120.256 131.403 120.729 131.785L119 133.924L117.271 131.785C117.76 131.389 118.37 131.173 119 131.174ZM110.574 115.951L126.778 132.156L125.482 133.452L120.733 128.704C120.174 128.518 119.589 128.424 119 128.424C117.691 128.424 116.488 128.882 115.544 129.645L114.393 128.219C115.597 127.243 117.081 126.676 118.629 126.6L116.25 124.22C114.941 124.591 113.721 125.224 112.664 126.08L111.511 124.654C112.499 123.854 113.608 123.217 114.798 122.768L112.704 120.674C111.662 121.17 110.682 121.788 109.785 122.514L108.631 121.088C109.47 120.41 110.376 119.813 111.337 119.308L109.277 117.248L110.574 115.951ZM121.291 124.102L119.198 122.009L119 122.008C121.837 122.008 124.442 122.999 126.489 124.654L125.336 126.08C124.155 125.123 122.772 124.447 121.291 124.102ZM119 117.424C122.928 117.424 126.535 118.797 129.367 121.088L128.215 122.514C125.608 120.402 122.354 119.252 119 119.258C118.195 119.258 117.405 119.322 116.635 119.447L115.081 117.892C116.336 117.587 117.65 117.424 119 117.424Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7529_5197",
    x1: 94.9769,
    y1: 62.5442,
    x2: 94.9769,
    y2: 121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9EEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCD8E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBonus4);
export default __webpack_public_path__ + "static/media/bonus4.4d056f8bd7da04d708a05692ee604e2d.svg";
export { ForwardRef as ReactComponent };